import INVOICE_REPORTS from "../graphql/reportsInvoices.gql";
import ORDER_REPORTS from "../graphql/reportsOrders.gql";
import ORDERS_LIST_REPORTS from "../graphql/reportsOrdersList.gql";
import SPECIFIC_SALES_ANALASYS_REPORT from "../graphql/reportsSpeficDataSales.gql";
import CUSTOMER_REPORT from "../graphql/reportCustomerBalance.gql";
import INVOICE_PDF from "../graphql/reportInvoicePdf.gql";
import ORDER_PDF from "../graphql/reportOrderPdf.gql";
import VIES_INFO from "../graphql/reportVIES.gql";

import UNLOCK_CUSTOMER_REPORT from "../graphql/checkUnlockedCustomer.gql";
import { apolloClient } from "./apollo";

export function getViesInformation(VAT){
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: VIES_INFO,
        variables: {
            vat: VAT
        }
    })
}
export function getOrderListByCustomer(cardCode, begin, end, userId, country = null, cardName = null) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: ORDERS_LIST_REPORTS,
        variables: {
            cardCode: cardCode,
            docEntry: (begin) ? begin : "",
            docNum: (end) ? end : "",
            userId: (userId) ? userId : "",
            country: (country) ? country : "",
            cardName: (cardName) ? cardName : "",

        }
    })
}
export function getOrdersByCustomer(cardCode, begin, end, userId,country = null, cardName = null) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: ORDER_REPORTS,
        variables: {
            cardCode: cardCode,
            docEntry: (begin) ? begin : "",
            docNum: (end) ? end : "",
            userId: (userId) ? userId : "",
            country: (country) ? country : "",
            cardName: (cardName) ? cardName : "",

        }
    })
}
export function getInvoicesByCustomer(cardCode, begin, end,userId) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: INVOICE_REPORTS,
        variables: {
            cardCode: cardCode,
            docEntry: (begin) ? begin : "",
            docNum: (end) ? end : "",
            userId: (userId) ? userId : ""
        }
    })
}
export function getBalanceByCustomer(cardCode) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: CUSTOMER_REPORT,
        fetchPolicy: "no-cache",
        variables: {
            cardCode: cardCode
        }
    })
}
export function getInvoicePdf(invoice, country) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: INVOICE_PDF,
        fetchPolicy: "no-cache",
        variables: {
            docNum: invoice.docNum,
            docEntry: invoice.docEntry,
            customerId: country
        }
    })
}
export function getOrderPdf(order, country) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: ORDER_PDF,
        fetchPolicy: "no-cache",
        variables: {
            docNum: order.docNum,
            docEntry: order.docEntry,
            customerId: country
        }
    })
}
export function getUnlockedCustomer(cardCode) {
    if (!window.navigator.onLine)
        return '';
    return apolloClient.mutate({
        mutation: UNLOCK_CUSTOMER_REPORT,
        fetchPolicy: "no-cache",
        variables: {
            cardCode: cardCode
        }
    })
}
export function getSpecificSalesDataReport(type, cardCode, begin, end, data) {
    debugger;
    return apolloClient.mutate({
        mutation: SPECIFIC_SALES_ANALASYS_REPORT,
        variables: {
            type: type,
            cardCode: cardCode,
            docEntry: (begin) ? begin : "",
            docNum: (end) ? end : "",
            userId: (data) ? JSON.stringify(data) : "",

        }
    })
}